import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import { type PartnerEventReview } from '@/api/routes/partners/partners.events.api';
import { formatEventDateTime, getEventReviewHistoryKey } from '@/domain/events/utils';
import { useTranslate } from '@/state/i18n';
import { radiusTokens } from '@/theme/themePrimitives';

interface Props {
  reviews: PartnerEventReview[];
}

/** History, newest first (P11–P13). Bodyprint decisions read "Equipe Bodyprint", never a name. */
const EventReviewHistory = ({ reviews }: Props) => {
  const t = useTranslate('domain.events.components.EventReviewHistory');
  const oldestId = reviews[reviews.length - 1]?.id;

  return (
    <Paper variant="outlined" sx={sx.paper}>
      <Typography variant="subtitle2" fontWeight={700}>
        {t('title')}
      </Typography>
      <Stack component="ol" gap={1.25} sx={sx.list}>
        {reviews.map((review) => (
          <Stack component="li" key={review.id} gap={0.25}>
            <Typography variant="body2">
              {t(`entries.${getEventReviewHistoryKey(review, review.id === oldestId)}`)}
            </Typography>
            <Typography variant="caption" color="text.secondary">
              {formatEventDateTime(review.createdAt)}
            </Typography>
          </Stack>
        ))}
      </Stack>
    </Paper>
  );
};

export default EventReviewHistory;

const sx = {
  paper: {
    borderRadius: radiusTokens.xxl,
    p: 2.5,
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
  },
  list: { m: 0, p: 0, listStyle: 'none' },
};
